var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 100,
    viewBox: "0 0 98 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4387_41436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1651 9.94351C51.9109 9.94351 54.1369 7.71758 54.1369 4.97176C54.1369 2.22593 51.9109 0 49.1651 0C46.4193 0 44.1934 2.22593 44.1934 4.97176C44.1934 7.71758 46.4193 9.94351 49.1651 9.94351Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M19.8872 11.6012C19.8872 14.2252 22.0969 16.4349 24.7209 16.4349C27.3448 16.4349 29.5545 14.2252 29.5545 11.6012C29.5545 8.97725 27.3448 6.76758 24.7209 6.76758C22.0969 6.76758 19.8872 8.83914 19.8872 11.6012Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M4.97168 28.1727C4.97168 30.6586 7.04325 32.7301 9.52912 32.7301C12.015 32.7301 14.0866 30.6586 14.0866 28.1727C14.0866 25.6868 12.015 23.6152 9.52912 23.6152C7.04325 23.6152 4.97168 25.6868 4.97168 28.1727Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M4.28124 54.6894C6.6457 54.6894 8.56247 52.7726 8.56247 50.4082C8.56247 48.0437 6.6457 46.127 4.28124 46.127C1.91677 46.127 0 48.0437 0 50.4082C0 52.7726 1.91677 54.6894 4.28124 54.6894Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5.10986 71.5382C5.10986 73.7479 6.90522 75.5433 9.11489 75.5433C11.3246 75.5433 13.1199 73.7479 13.1199 71.5382C13.1199 69.3286 11.3246 67.5332 9.11489 67.5332C6.90522 67.5332 5.10986 69.3286 5.10986 71.5382Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.0249 88.6624C20.0249 90.734 21.6822 92.3912 23.7537 92.3912C25.8253 92.3912 27.4825 90.734 27.4825 88.6624C27.4825 86.5908 25.8253 84.9336 23.7537 84.9336C21.8203 84.9336 20.0249 86.5908 20.0249 88.6624Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M45.7124 95.8446C45.7124 97.7781 47.2316 99.4353 49.3031 99.4353C51.2366 99.4353 52.8938 97.9162 52.8938 95.8446C52.8938 93.9112 51.3747 92.2539 49.3031 92.2539C47.2316 92.392 45.7124 93.9112 45.7124 95.8446Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M71.6763 88.1114C71.6763 89.9067 73.1954 91.4259 74.9908 91.4259C76.7861 91.4259 78.3053 89.9067 78.3053 88.1114C78.3053 86.316 76.7861 84.7969 74.9908 84.7969C73.1954 84.7969 71.6763 86.316 71.6763 88.1114Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.5913 70.1572C86.5913 71.8145 87.9724 73.1955 89.6296 73.1955C91.2868 73.1955 92.6679 71.8145 92.6679 70.1572C92.6679 68.4999 91.2868 67.1189 89.6296 67.1189C87.9724 66.9808 86.5913 68.3618 86.5913 70.1572Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M91.563 49.9945C91.563 51.5137 92.8059 52.7566 94.3251 52.7566C95.8442 52.7566 97.0872 51.5137 97.0872 49.9945C97.0872 48.4754 95.8442 47.2324 94.3251 47.2324C92.8059 47.2324 91.563 48.4754 91.563 49.9945Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M84.52 24.1689C84.52 25.5499 85.6249 26.7929 87.144 26.7929C88.525 26.7929 89.768 25.6881 89.768 24.1689C89.768 22.7879 88.6631 21.5449 87.144 21.5449C85.6249 21.5449 84.52 22.6498 84.52 24.1689Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M69.6046 11.8772C70.9013 11.8772 71.9524 10.8261 71.9524 9.52942C71.9524 8.23278 70.9013 7.18164 69.6046 7.18164C68.308 7.18164 67.2568 8.23278 67.2568 9.52942C67.2568 10.8261 68.308 11.8772 69.6046 11.8772Z",
    fill: "#990A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5662 48.3368H59.7991V70.9859H37.2881V48.3368H30.521L48.6127 28.5879L66.5662 48.3368Z",
    fill: "#990A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4387_41436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.0874,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopup);
export default __webpack_public_path__ + "static/media/topup.926922b476ba0cd54d069a9d018a92de.svg";
export { ForwardRef as ReactComponent };